import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Terminos = () => {
    return (
        <section className='bg-primary text-white'>
            <Container className='py-5'>
                <Row className='justify-content-center'>
                    <Col lg={8} md={8} sm={12} xs={12} className='py-5'>
                        <h1>Términos y Condiciones de nuestra Newsletter</h1>

                        <h2>Contenido de la Newsletter</h2>
                        <p>
                            La newsletter es un servicio informativo que ofrece resúmenes de noticias relevantes seleccionadas de medios públicos y abiertos de distintos países. Los resúmenes incluyen enlaces a las fuentes originales para la consulta directa del contenido completo.
                        </p>

                        <h2>Fuentes de Información</h2>
                        <p>
                            Toda la información incluida en la newsletter proviene de fuentes públicas y abiertas disponibles al momento de su elaboración. No realizamos modificaciones ni verificaciones adicionales al contenido publicado por dichas fuentes, limitándonos a resumir y vincular el material publicado.
                        </p>

                        <h2>Exención de Responsabilidad</h2>
                        <p>
                            No garantizamos la exactitud, veracidad, actualidad o integridad del contenido proporcionado en los resúmenes o de las fuentes originales a las que redirigimos mediante enlaces.
                        </p>
                        <p>
                            No asumimos responsabilidad alguna por daños o perjuicios derivados de la interpretación, uso o confianza en el contenido compartido en la newsletter o en los enlaces proporcionados.
                        </p>
                        <p>
                            Los enlaces compartidos pueden conducir a sitios web externos cuyo contenido está fuera de nuestro control. No garantizamos la disponibilidad ni la calidad de dichos sitios o su contenido.
                        </p>

                        <h2>Uso de la Información</h2>
                        <p>
                            El contenido proporcionado en la newsletter es exclusivamente de carácter informativo y educativo. Bajo ninguna circunstancia debe considerarse como asesoría profesional, legal, financiera, política o de cualquier otro tipo.
                        </p>

                        <h2>Propiedad Intelectual</h2>
                        <p>
                            Los derechos de propiedad intelectual de los resúmenes elaborados para la newsletter pertenecen al sitio web sereslatam.com. El uso del contenido está permitido únicamente para fines personales y no comerciales, salvo autorización previa y por escrito.
                        </p>

                        <h2>Modificaciones al Servicio</h2>
                        <p>
                            Nos reservamos el derecho de modificar, suspender o interrumpir la distribución de la newsletter en cualquier momento, sin previo aviso.
                        </p>

                        <h2>Aceptación de los Términos y Condiciones</h2>
                        <p>
                            Al suscribirte a la newsletter, aceptas los presentes términos y condiciones en su totalidad.
                        </p>

                        <h2>Ley Aplicable y Jurisdicción</h2>
                        <p>
                            Estos términos y condiciones se rigen por las leyes de la República de Guatemala. En caso de controversias, las partes se someten a la jurisdicción de los tribunales correspondientes en Guatemala.
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Terminos;